import { EapSettingsListProvider } from 'modules/settings/contexts/eap-settings/providers/eap-settings-list.provider';
import { SettingsDevicesEapSettingsContainer } from 'modules/settings/pods/settings-devices/settings-devices-eap-settings/settings-devices-eap-settings-dashboard/settings-devices-eap-settings-dashboard.container';
import { DEVICE_TYPE_SOURCE, DeviceTypesProvider, fetchDeviceTypesFromADM } from '@root/src/core/contexts/device-types';

export const SettingsDevicesEapSettingsScene = () => (
    <DeviceTypesProvider fetchStrategy={fetchDeviceTypesFromADM} source={DEVICE_TYPE_SOURCE.ADM}>
        <EapSettingsListProvider>
            <SettingsDevicesEapSettingsContainer />
        </EapSettingsListProvider>
    </DeviceTypesProvider>
);

export default SettingsDevicesEapSettingsScene;
